'use client'
import { useHasAllAccessQuery } from '@repo/cf-user/hooks/use-user-data'

export function HasAllAccess({
  children,
  hideOnAllAccess = true,
  renderWhileLoading = true,
}: PropsWithChildren<{ hideOnAllAccess?: boolean; renderWhileLoading?: boolean }>) {
  const { data, isPending } = useHasAllAccessQuery()

  if (isPending) {
    if (!renderWhileLoading) {
      return null
    }
    return (
      <div className="mx-auto flex w-fit animate-pulse bg-[#E5E4E2]">
        <div className="opacity-0">{children}</div>
      </div>
    )
  }

  if (hideOnAllAccess) {
    return data ? null : children
  }

  return data ? children : null
}
